/** archivo de funciones asincronas para el modulo de envíos masivos */
import axiosMailUpdate from '../services/axiosApi'
var functionsForRequests = {
    async allCategories() {
        //lista todas las categorias
        const response = await axiosMailUpdate.get('api/v1/categories?sort_by=nombrecategoria')
        this.response = response.data.data
        return this.response
    },
    async allCities() {
        //lista todas las ciudades
        const response = await axiosMailUpdate.get('api/v1/cities?sort_by=nombreciudad')
        this.response = response.data.data
        return this.response
    },
    async allStates() {
        //lista todos los estados
        const response = await axiosMailUpdate.get('api/v1/states?sort_by=nombreestado')
        this.response = response.data.data
        return this.response
    },
    async allUrbanizations() {
        //lista todas las urbanizaciones
        const response = await axiosMailUpdate.get('api/v1/urbanizations?sort_by=nameUrbanization')
        this.response = response.data.data
        return this.response
    },
    async citiesByState(idState) {
        //lista las ciudades de un estado
        const response = await axiosMailUpdate.get('api/v1/states/' + idState + '/cities?sort_by=nombreciudad')
        this.response = response.data.data
        return this.response
    },
    async urbanizationsByCity(idCity) {
        //lista las urbanizaciones de una ciudad
        const response = await axiosMailUpdate.get('api/v1/cities/' + idCity + '/urbanizations?sort_by=nameUbanization')
        this.response = response.data.data
        return this.response
    },
    async urbanizationsByState(idState) {
        // lista todas las urbanizaciones de un estado
        const response = await axiosMailUpdate.get('api/v1/states/' + idState + '/citiesurbanizations?sort_by=nameUrbanization')
        this.response = response.data.data
        return this.response
    },
    async consultQuantBussiness(dataForPost) {
        // consulta la cantidad total de empresas para el envio
        const response = await axiosMailUpdate.post('api/v1/request/quantitycompany',dataForPost)
        this.response = response.data.data
        return this.response
    },
    async scheduleRequest(dataForPost) {
        // consulta la cantidad total de empresas para el envio
        const response = await axiosMailUpdate.post('api/v1/requests',dataForPost)
        this.response = response.data.data
        return this.response
    },
}

export default functionsForRequests